import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const VerifyEmail = () => {
const { token } = useParams();
const navigate = useNavigate();

const [message, setMessage] = useState("Verifying your email...");
const [loading, setLoading] = useState(true);
const [success, setSuccess] = useState(false);

useEffect(() => {
const verifyEmail = async () => {
try {
const API_URL =
process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const response = await axios.get(  
      `${API_URL}/auth/verify-user/${token}`  
    );  

    setMessage(  
      response.data.message || "Email verified successfully!"  
    );  
    setSuccess(true);  
  } catch (error) {  
    setSuccess(false);  

    setMessage(  
      error.response?.data?.message ||  
        "Verification link is invalid or expired."  
    );  
  } finally {  
    setLoading(false);  
  }  
};  

if (token) {  
  verifyEmail();  
} else {  
  setMessage("Verification token is missing.");  
  setLoading(false);  
}

}, [token]);

return (
<div
style={{
minHeight: "100vh",
display: "flex",
justifyContent: "center",
alignItems: "center",
background: "#f4f8f6",
padding: "20px",
}}
>
<div
style={{
width: "100%",
maxWidth: "500px",
background: "#ffffff",
padding: "40px",
borderRadius: "15px",
textAlign: "center",
boxShadow: "0 5px 25px rgba(0,0,0,0.1)",
}}
>
<h2
style={{
color: success ? "#008251" : "#d9534f",
marginBottom: "20px",
}}
>
{loading
? "Verifying Email..."
: success
? "Email Verified Successfully!"
: "Email Verification Failed"}
</h2>

<p  
      style={{  
        fontSize: "16px",  
        color: "#555",  
        marginBottom: "25px",  
      }}  
    >  
      {message}  
    </p>  

    {!loading && (  
      <button  
        onClick={() => navigate("/login")}  
        style={{  
          background: "#008251",  
          color: "#fff",  
          border: "none",  
          padding: "12px 25px",  
          borderRadius: "8px",  
          cursor: "pointer",  
          fontSize: "16px",  
        }}  
      >  
        Go to Login  
      </button>  
    )}  
  </div>  
</div>

);
};

export default VerifyEmail; 